export const CHAKRA_COLORS = {
  black: "#140900",
  white: "#FFFDFB",

  burntOrange: "#BE5103",
  palePeach: "#F0EBE7",

  blackAlpha: {
    50: "rgba(20, 9, 0, 0.04)",
    100: "rgba(20, 9, 0, 0.06)",
    200: "rgba(20, 9, 0, 0.08)",
    300: "rgba(20, 9, 0, 0.16)",
    400: "rgba(20, 9, 0, 0.24)",
    500: "rgba(20, 9, 0, 0.36)",
    600: "rgba(20, 9, 0, 0.48)",
    700: "rgba(20, 9, 0, 0.64)",
    800: "rgba(20, 9, 0, 0.80)",
    900: "rgba(20, 9, 0, 0.92)",
  },

  whiteAlpha: {
    50: "rgba(255, 253, 251, 0.04)",
    100: "rgba(255, 253, 251, 0.06)",
    200: "rgba(255, 253, 251, 0.08)",
    300: "rgba(255, 253, 251, 0.16)",
    400: "rgba(255, 253, 251, 0.24)",
    500: "rgba(255, 253, 251, 0.36)",
    600: "rgba(255, 253, 251, 0.48)",
    700: "rgba(255, 253, 251, 0.64)",
    800: "rgba(255, 253, 251, 0.80)",
    900: "rgba(255, 253, 251, 0.92)",
  },

  // Override chakra's blue-hue gray
  // with a neutral one
  gray: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)",
  },
};
